import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';

function InfoWindowCloseButton(props) {
    const onClick = (e) => {
        e.stopPropagation();
        props.onClick();
    }
    return (
        <IconButton
            aria-label="close"
            size="small"
            sx={{
                position: 'absolute',
                top: 5,
                right: 5,
                zIndex: 999,
            }}
            onClick={onClick}
        >
            <CloseIcon fontSize="inherit" />
        </IconButton>
    );
}

InfoWindowCloseButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default InfoWindowCloseButton;
